import { render, staticRenderFns } from "./app.vue?vue&type=template&id=33dd667e&"
import script from "./app.js?vue&type=script&lang=js&"
export * from "./app.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33dd667e')) {
      api.createRecord('33dd667e', component.options)
    } else {
      api.reload('33dd667e', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=33dd667e&", function () {
      api.rerender('33dd667e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/app/app.vue"
export default component.exports